import { Link } from "react-router-dom";
import images from "../../assets/images";
import { Dropdown } from "../../components/dropdown/Dropdown";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useState } from "react";
import { themeQuartz } from "ag-grid-community";
import { regionRowType } from "../../types/api";
import { useRegionStore } from "../../store/store";

const gridTheme = themeQuartz.withParams({
  backgroundColor: "#fff",
  foregroundColor: "#2a2a2a",
  headerTextColor: "#2a2a2a",
  headerBackgroundColor: "#E9F5FF",
  oddRowBackgroundColor: "rgb(0, 0, 0, 0.03)",
  headerColumnResizeHandleColor: "rgb(126, 46, 132)",
  fontSize: "0.75rem",
  headerFontWeight: "bold",
});

const Regions: React.FC = () => {
  const [rowData, setRowData] = useState<regionRowType[]>([]);
  const [originalData, setOriginalData] = useState<regionRowType[]>([]);

  const { regions, fetchRegions, loading } = useRegionStore();

  useEffect(() => {
    const resData = regions?.map((region: any) => ({
      id: region._id,
      regionName: region.regionName,
      regionCode: region.regionCode,
      premisesCount: region.premisesCount,
      tenantId: region.tenantId,
      lastUpdate: new Date(region.updatedAt).toLocaleDateString("en-US"),
      updatedAt: region.updatedAt,
      createdAt: new Date(region.createdAt).toLocaleDateString("en-US"),
      action: null,
    }));
    setRowData(resData);
    setOriginalData(resData);
  }, [regions]);

  useEffect(() => {
    fetchRegions();
  }, []);

  const [columnDefs, setColDefs] = useState<any>([
    {
      field: "regionCode",
      headerName: "Region Code",
      sortable: false,
      // minWidth: 20,
      minWidth: 120,
      maxWidth: 160,
      flex: 0,
      headerStyle: {
        backgroundColor: "#e9f5ff",
      },
      filter: false,
      cellStyle: {
        textAlign: "left",
        padding: "10px 0 0 15px",
      },
    },
    {
      field: "regionName",
      headerName: "Region",
      sortable: false,
      // minWidth: 20,
      minWidth: 120,
      // maxWidth: 160,
      flex: 1,
      headerStyle: { backgroundColor: "#e9f5ff" },
      filter: false,
      cellStyle: { padding: "10px 0 0 10px", textAlign: "left" },
    },
    {
      field: "premisesCount",
      headerName: "No. of Premises",
      sortable: false,
      // minWidth: 20,
      minWidth: 120,
      maxWidth: 160,
      flex: 0,
      headerStyle: { backgroundColor: "#e9f5ff" },
      filter: false,
      valueGetter: (params: any) => {
        const noOfPremises = params.data.premisesCount;
        return noOfPremises && noOfPremises > 0 ? noOfPremises : "N/A"
      },
      cellStyle: { padding: "10px 10px 0 0", textAlign: "center" },
    },
    {
      field: "lastUpdate",
      headerName: "Last Update",
      sortable: false,
      headerStyle: { backgroundColor: "#e9f5ff" },
      flex: 0,
      minWidth: 120,
      maxWidth: 160,
      filter: false,
      cellStyle: { padding: "10px 0 0 10px", textAlign: "left" },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      sortable: false,
      headerStyle: { backgroundColor: "#e9f5ff" },
      flex: 0,
      minWidth: 120,
      maxWidth: 160,
      filter: false,
      cellStyle: { padding: "10px 0 0 10px", textAlign: "left" },
    },
    {
      field: "action",
      headerName: "Action",
      cellStyle: { padding: "10px 0 0 0 ", textAlign: "center" },
      // minWidth: 20,
      minWidth: 50,
      maxWidth: 100,
      headerStyle: { backgroundColor: "#e9f5ff" },
      flex: 0,
      cellRenderer: (params: any) => (
        <div className="flex gap-x-3 pt-2">
          <Link to={`/regions/view-region/${params.data.id}`}>
            <img className="iconTd" src={images.viewIcon} />
          </Link>
          <Link to={`/regions/update-region/${params.data.id}`}>
            <img className="iconTd" src={images.editIcon} />
          </Link>
        </div>
      ),
      filter: false,
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      filter: false,
    };
  }, []);
  const theme = useMemo(() => {
    return gridTheme;
  }, []);

  const searchRegions = async (keyword: any) => {
    if (!keyword.trim()) {
      setRowData(originalData);
      return;
    }

    const filteredData = originalData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(keyword.toLowerCase())
      )
    );
    setRowData(filteredData);
  };

  return (
    <>
      <div className="px-2 py-4 mt-14">
        <div className="flex justify-between items-center mb-4">
          <h2 className="ml-2">Regions</h2>
          <span className="flex items-center">
            <Link
              to="/regions/add-region"
              className="flex items-center justify-center font-semibold gap-3 bg-[#0fa9a6] text-white px-4 py-2 rounded-full"
            >
              <img src={images.addPremiessIcon} width={25} alt="" />
              ADD REGION
            </Link>
          </span>
        </div>

        <div className="tableBlock w-full ">
          <div className="card">
            <div className="tableSearchBlock d-flex justify-content-between">
              <div className="leftTableSearchBlock">
                <div className="input-affix">
                  <i className="prefix-icon anticon anticon-search"></i>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => searchRegions(e.target.value)}
                    placeholder="Search Here..."
                  />
                </div>
              </div>

              {/* <div className="rightTableSearchBlock d-flex ">
                <span className="flex gap-4">
                  <Dropdown />
                </span>
              </div> */}
            </div>

            {rowData?.length > 0 ? (
              <div className="ag-theme-alpine w-full h-[650px] pl-2 border-0 rounded-lg shadow-lg">
                <AgGridReact
                  rowData={rowData}
                  columnDefs={columnDefs}
                  theme={theme}
                  headerHeight={65}
                  rowHeight={50}
                  defaultColDef={defaultColDef}
                />
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center h-64">
                <p className="text-gray-500 text-lg mb-4">
                  No Regions added yet
                </p>
                {/* <button className="font-semibold bg-[#0fa9a6] text-white px-4 py-2 rounded-full transition-colors">
                  Add Region
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Regions;
